import { Connection, PublicKey } from "@solana/web3.js";
import * as solanaStakePool from "@solana/spl-stake-pool";

const JITO_STAKE_POOL = new PublicKey("Jito4APyf642JPZPx3hGc6WWJ8zPKtRbRs4P815Awbb");
const STAKE_POOL_PROGRAM = new PublicKey("SPoo1Ku8WFXoNDMHPsrGSTSG1Y47rzgn41SLUNakuHy");

export interface JitoStakePoolAccounts {
    stakePoolProgram: PublicKey;
    jitoStakePool: PublicKey;
    stakePoolWithdrawAuthority: PublicKey;
    reserveStakeAccount: PublicKey;
    stakeFeeAccount: PublicKey;
}

export async function fetchJitoStakePoolAccounts(connection: Connection): Promise<JitoStakePoolAccounts> {
    const stakePool = await solanaStakePool.getStakePoolAccount(connection, JITO_STAKE_POOL);

    const [stakePoolWithdrawAuthority] = PublicKey.findProgramAddressSync(
        [JITO_STAKE_POOL.toBuffer(), Buffer.from("withdraw")],
        STAKE_POOL_PROGRAM
    );

    return {
        stakePoolProgram: STAKE_POOL_PROGRAM,
        jitoStakePool: JITO_STAKE_POOL,
        stakePoolWithdrawAuthority,
        reserveStakeAccount: stakePool.account.data.reserveStake,
        stakeFeeAccount: stakePool.account.data.managerFeeAccount,
    };
}
